import React from "react";
import SubscribersView from "../../../views/dashboard/subscribers";

const Subscribers = () => {
  return <SubscribersView />;
};

export default Subscribers;
